var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6671 18.9672V13.5361",
    stroke: "#CD4646",
    strokeWidth: 1.58044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2257 18.9672V13.5361",
    stroke: "#CD4646",
    strokeWidth: 1.58044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7804 18.9672V13.5361",
    stroke: "#CD4646",
    strokeWidth: 1.58044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48047 18.9669H18.9671",
    stroke: "#CD4646",
    strokeWidth: 1.58044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48047 13.536H18.9671V11.4217L14.2238 9.48047L9.48047 11.4217V13.536Z",
    stroke: "#CD4646",
    strokeWidth: 1.58044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7098 9.48118C23.7098 7.51643 25.3026 5.92369 27.2673 5.92369C25.3026 5.92369 23.7098 4.33095 23.7098 2.36621C23.7098 4.33095 22.1171 5.92369 20.1523 5.92369C22.1171 5.92369 23.7098 7.51643 23.7098 9.48118",
    stroke: "#CD4646",
    strokeWidth: 1.58044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8957 14.2242V18.9675C24.8957 22.2421 22.2411 24.8967 18.9665 24.8967H9.47992C6.20535 24.8967 3.55078 22.2421 3.55078 18.9675V9.48089C3.55078 6.20632 6.20535 3.55176 9.47992 3.55176H16.5949",
    stroke: "#4B4A4A",
    strokeWidth: 1.58044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankLogo);
export default __webpack_public_path__ + "static/media/bank-logo.a0cbf8a5596d4d29f1df113f50881bf5.svg";
export { ForwardRef as ReactComponent };